import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class CamionChoferService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerSegunPatente(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: camion_choferInputType) {
            camion_chofer {
                obtenerSegunId(entidad: $entidad) {
                    mensajes {
                        codigo
                        contexto
                        texto
                        tipo
                    }
                    respuesta {
                        patente
                        rut_chofer
                    }
                }
            }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.camion_chofer.obtenerSegunId;
            callback({ mensajes, respuesta });
        });
    }
}
CamionChoferService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CamionChoferService_Factory() { return new CamionChoferService(i0.ɵɵinject(i1.GraphQLClient)); }, token: CamionChoferService, providedIn: "root" });
